module.exports = __webpack_public_path__ + "img/corses.939304d8.png";